(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('ExchangerateSearch', ExchangerateSearch);

    ExchangerateSearch.$inject = ['$resource'];

    function ExchangerateSearch($resource) {
        var resourceUrl =  'api/_search/exchangerates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
